<nz-avatar
  [nzSize]="32"
  [nzSrc]="paymentChannelsLogosUrl[paymentChannelType]"
  [nzAlt]="PaymentChannelType"
  [style]="'color:' + ColorsConst.white + '; background-color:' + ImgBgColor"
>
</nz-avatar>
